module.exports = __webpack_public_path__ + "static/media/01_avatar_male.493fa307.png";